import { createContext, useContext } from "react";

// §10.1/D68 — stellt dem ResultRenderer die persistierten Job-SIGNALE bereit
// (executed_pipeline_spec.signals, node→port→value), OHNE die ResultRendererProps-Signatur
// (`assets: AssetRef[]`, Contract §3.4) zu ändern — analog dem ResultUrlContext (D65). Speist
// den SpriteSheetPlayer (`pack.meta` = Grid, D68) und die Validierungs-Leiste (`validate`/
// `normalize`-Signale, D76). Fehlt ein Signal, greift der jeweilige Fallback im Renderer.
// (Die D94-LoopScore-ANZEIGE entfiel per D107 und bleibt weg; `signals.loop.loopScore`
// existiert seit D108 (Cut-only) wieder — Diagnose via DB, bewusst keine UI.)

export type JobSignals = Record<string, Record<string, unknown>>;

const ResultMetaContext = createContext<JobSignals>({});

export const ResultMetaProvider = ResultMetaContext.Provider;

/** Signal eines Knoten-Ports aus dem geöffneten Job (oder undefined). */
export function useResultSignal(nodeId: string, port: string): unknown {
  return useContext(ResultMetaContext)[nodeId]?.[port];
}

// D76 — der ResultRenderer braucht für den „Trotzdem generieren"-Pfad (spritesheet) NEBEN den
// Signalen auch den Job-STATUS (z.B. "failed" beim fehlgeschlagenen Validierungs-Lauf). Wie bei
// ResultUrl/ResultMeta fließt er über einen eigenen Context, ohne die ResultRendererProps-Signatur
// (`assets`, §3.4) anzufassen. Eigener Context (statt den Signals-Pfad zu überladen) hält die zwei
// Belange — node→port→value vs. ein Skalar — sauber getrennt und konsistent mit dem Muster.
const JobStatusContext = createContext<string | null>(null);

export const JobStatusProvider = JobStatusContext.Provider;

/** Status des geöffneten Jobs (z.B. "failed"/"succeeded") oder null, wenn keiner offen ist. */
export function useJobStatus(): string | null {
  return useContext(JobStatusContext);
}
